import { Outlet } from "react-router-dom";

export function Member() {
  return (
    <>
      <Outlet />
    </>
  );
}
